export const TEMPLATE_LAYOUT = {
  FIXED: 'fixed',
  PAGE: 'page',
  AUTOMATIC: 'automatic',
  SEQUENCE: 'sequence',
};

export const PLACEHOLDER_TYPE = {
  PHOTO: 'photo',
  MEDIA: 'media',
  TEXT: 'text',
  STATIC: 'static',
  VECTOR: 'vector',
};

export const PAGE_OPTION = {
  TOC: 'table-of-contents',
  PHOTO: 'photo',
  TIMELINE: 'personal-timeline',
  FAMILY_SHEET: 'family-sheet',
  FAMILY_TREE: 'family-tree',
  RECORD: 'record',
  TITLE: 'title',
  DEDICATION: 'dedication',
  DIVIDER: 'divider',
  INDEX: 'book-index',
};

export const ORIENTATION = {
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
  SQUARE: 'square',
};

export const TREE_TYPE = {
  SINGLE: 'single',
  COMBO: 'combo',
  DESC: 'desc',
  FAN: 'fan',
};

export const TREE_TYPE_ALIASES = {
  [TREE_TYPE.SINGLE]: ['single', 'std', 'standard'],
  [TREE_TYPE.COMBO]: ['combo', 'combination'],
  [TREE_TYPE.DESC]: ['desc'],
  [TREE_TYPE.FAN]: ['fan'],
};
